<template>
    <a v-if="!checkActive" @click="addToGroup">
        <ion-icon name="ios-checkmark-circle-outline"></ion-icon>
        <!-- <ion-icon name="ios-radio-button-off"></ion-icon> -->
    </a>
    <a v-else @click="removeFromGroup">
        <ion-icon name="ios-checkmark-circle"></ion-icon>
    </a>
</template>

<script>
    export default {
        data() {
            return {
                checkActive: false
            }
        },
        methods: {
            addToGroup() {
                this.checkActive = true
                this.$emit('userAdded')
            },
            removeFromGroup() {
                this.checkActive = false
                this.$emit('userRemoved')
            }
        }
    }
</script>

<style scoped>
    ion-icon {
        color: #51c715;
        font-size: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/components/groups/GroupsAddButton.vue